import { type UseQueryResult, useQuery } from 'react-query';
import {
  OptionAwardService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_OptionAwardListDto,
} from '../../services/wealthlane-award-services';
// import { ParticipantService } from '../../services/wealthlane-customer-services';
import { type TableParamsType } from '../../types/common';

const useGetOptionParticipantList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  filterData: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_OptionAwardListDto | undefined,
  unknown
> => {
  // const {
  //   approvalStatusId,
  //   optionAcceptance,
  //   fromDate,
  //   toDate,
  //   createdFromDate,
  //   createdToDate,
  //   employeeStatusId,
  //   isEarlyExercisable,
  //   grantFromDate,
  //   grantToDate,
  // } = filterData;

  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    approvalStatusId,
    optionAcceptance,
    fromDate,
    toDate,
    createdFromDate,
    createdToDate,
    employeeStatusId,
    isEarlyExercisable,
    grantFromDate,
    grantToDate,
    _force,
  } = tableInfo;
  const optionStatus = 0;

  const OptionParticipantList = useQuery(
    [
      'getOptionParticipantList',
      approvalStatusId,
      fromDate,
      toDate,
      grantFromDate,
      grantToDate,
      employeeStatusId,
      optionStatus,
      optionAcceptance,
      createdFromDate,
      createdToDate,
      isEarlyExercisable,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        OptionAwardService.getApiAwardApiAppOptionAwardOptionAwardList(
          approvalStatusId ?? [0],
          fromDate,
          toDate,
          createdFromDate,
          createdToDate,
          grantFromDate,
          grantToDate,
          employeeStatusId ?? [0],
          optionStatus,
          optionAcceptance,
          isEarlyExercisable,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return OptionParticipantList;
};

export default useGetOptionParticipantList;
